import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import experiments from '@reverbdotcom/commons/src/experiments';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';

export function isKlarnaAvailable(acceptedPaymentMethods: string[], user: Partial<IUser>) {
  if (!acceptedPaymentMethods) { return false; }

  return acceptedPaymentMethods.includes('klarna_account') &&
    isUserEligibleForKlarna(user);
}

export function isGuestUserEligibleForKlarna(acceptedPaymentMethods: string[], user: Partial<IUser>) {
  if (!acceptedPaymentMethods) { return false; }

  return acceptedPaymentMethods.includes('klarna_account') &&
    user.loggedOut;
}

export function filterBuyerPaymentMethods(acceptedPaymentMethods: string[], user: Partial<IUser>) {
  if (!acceptedPaymentMethods) {
    return [];
  }

  function isPaymentMethodAvailable(paymentMethod: string) {
    if (paymentMethod == 'klarna_account' && !isUserEligibleForKlarna(user)) {
      return false;
    }
    return true;
  }

  return acceptedPaymentMethods.filter(isPaymentMethodAvailable);
}

function isUserEligibleForKlarna(user: Partial<IUser>) {
  return !user.loggedOut ||
    isUserInKlarnaGuestExperiment(user);
}

function isUserInKlarnaGuestExperiment(user: Partial<IUser>) {
  return user.loggedOut &&
    isExperimentEnabled(user, experiments.KLARNA_GUEST_CHECKOUT);
}
